import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

const INTEGER_FILTER_KEYS = ["connection", "role_id", "status", "cmp_type_id"];

export const prepareFilterAttrs = (data: Record<string, any>) => {
  const isInteger = (num: any) => /^-?\d+$/.test(num);
  const MAX_INT = Number.MAX_SAFE_INTEGER;

  return Object.entries(data).reduce((queries, [key, value]) => {
    if (isInteger(value)) {
      const v = INTEGER_FILTER_KEYS.includes(key) ? parseInt(value, 10) : value;
      if (v <= MAX_INT) {
        queries[key] = v;
        return queries;
      }
    }
    if (![null, undefined, ""].includes(value as any)) {
      queries[key] = value;
      return queries;
    }
    return queries;
  }, {} as Record<string, any>);
};

export default function useFilter(currentModule: string) {
  const store = useStore();
  const route = useRoute();
  const router = useRouter();
  const module = computed(() => currentModule || "default");
  const query = computed(() => route.query as any);

  const moduleAttrs = computed(() => store.state.filter.module[module.value] || {});

  const queryAttrs = computed(() => {
    const attrs = prepareFilterAttrs(query.value);
    return attrs;
  });

  const filterAttrs = computed(() => prepareFilterAttrs(Object.assign({ ...moduleAttrs.value }, { ...queryAttrs.value })));

  const setFilter = (attrs: any) => {
    store.dispatch("setModuleFilter", { module: module.value, attrs: attrs });
  };

  const setFilterQuery = async (attrs: any, routeParams?: { name: string; params: Record<string, any> }, enableHistory = true) => {
    const _attrs = prepareFilterAttrs(attrs);
    await store.dispatch("setModuleFilter", { module: module.value, attrs: _attrs });
    const params = {
      query: _attrs,
      name: routeParams?.name,
      params: routeParams?.params,
    };
    if (enableHistory) {
      await router.push(params);
    } else {
      await router.replace(params);
    }
  };

  return {
    filterAttrs,
    queryAttrs,
    moduleAttrs,
    query,
    setFilter,
    setFilterQuery,
  };
}
